import { GET_TRANSACTION, GET_TRANSACTION_SUCCESS, GET_TRANSACTION_FAIL, DELETE_TRANSACTION, DELETE_TRANSACTION_SUCCESS, DELETE_TRANSACTION_FAIL, UPDATE_TRANSACTION, UPDATE_TRANSACTION_SUCCESS, UPDATE_TRANSACTION_FAIL, ADD_NEW_TRANSACTION, ADD_TRANSACTION_SUCCESS, ADD_TRANSACTION_FAIL, TRANSACTION_LOADING, TRANSACTION_RESET, TRANSACTION_RESET_CREATE, GET_TRANSACTION_ONE } from "./actionType";

export const resetTransactionState = (actionType) => ({
  type: TRANSACTION_RESET,
  payload: { actionType },
});

export const resetTransactionCreateState = (actionType) => ({
  type: TRANSACTION_RESET_CREATE,
  payload: { actionType },
});

export const getTransactionSuccess = (actionType, data) => ({
  type: GET_TRANSACTION_SUCCESS,
  payload: { actionType, data },
});

export const getTransactionFail = (actionType, error) => ({
  type: GET_TRANSACTION_FAIL,
  payload: { actionType, error },
});

export const getTransaction = (data) => ({
  type: GET_TRANSACTION,
  payload: data,
});

export const getTransactionOne = (data) => ({
  type: GET_TRANSACTION_ONE,
  payload: data,
});

export const getTransactionLoading = () => ({
  type: TRANSACTION_LOADING,
});

export const deleteTransaction = (data) => ({
  type: DELETE_TRANSACTION,
  payload: data,
});

export const deleteTransactionSuccess = (data) => ({
  type: DELETE_TRANSACTION_SUCCESS,
  payload: data,
});

export const deleteTransactionFail = (error) => ({
  type: DELETE_TRANSACTION_FAIL,
  payload: error,
});

export const updateTransaction = (data) => ({
  type: UPDATE_TRANSACTION,
  payload: data,
});

export const updateTransactionFail = (error) => ({
  type: UPDATE_TRANSACTION_FAIL,
  payload: error,
});

export const updateTransactionSuccess = (data) => ({
  type: UPDATE_TRANSACTION_SUCCESS,
  payload: data,
});

export const addNewTransaction = (data) => ({
  type: ADD_NEW_TRANSACTION,
  payload: data,
});

export const addTransactionSuccess = (data) => ({
  type: ADD_TRANSACTION_SUCCESS,
  payload: data,
});

export const addTransactionFail = (error) => ({
  type: ADD_TRANSACTION_FAIL,
  payload: error,
});
